"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfType = void 0;
var PdfType;
(function (PdfType) {
    PdfType["PRINT"] = "PRINT";
})(PdfType || (exports.PdfType = PdfType = {}));
//# sourceMappingURL=pdf.js.map